var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.096,
    height: 40,
    viewBox: "0 0 53.096 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(-471 -384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(476.35 393.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(27.912)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 13.76,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 13.76,
    transform: "translate(0 2.949)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 13.76,
    transform: "translate(0 5.897)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 13.76,
    transform: "translate(0 8.846)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 13.76,
    transform: "translate(0 11.794)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 13.76,
    transform: "translate(0 14.743)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "table-svgrepo-com",
    d: "M8.068,5.418a.884.884,0,0,1,.884-.884h3.534a.884.884,0,1,1,0,1.767H8.952A.884.884,0,0,1,8.068,5.418ZM20.437,1.884a.884.884,0,0,1-.884.884H18.67V19.554a.884.884,0,1,1-1.767,0V9.835H4.534v9.719a.884.884,0,1,1-1.767,0V2.767H1.884A.884.884,0,1,1,1.884,1h17.67A.884.884,0,0,1,20.437,1.884ZM16.9,2.767H4.534v5.3H16.9Z",
    transform: "translate(-1 9.279)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(471 384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box-fragile-svgrepo-com",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M50.491,51.307H2.6A2.536,2.536,0,0,0,0,53.761V88.853a2.536,2.536,0,0,0,2.6,2.454H50.491a2.536,2.536,0,0,0,2.6-2.454V53.761A2.536,2.536,0,0,0,50.491,51.307Zm.942,37.546a.917.917,0,0,1-.942.888H2.6a.917.917,0,0,1-.942-.888V53.761a.917.917,0,0,1,.942-.888H50.491a.917.917,0,0,1,.942.888V88.853Z",
    transform: "translate(0 -51.307)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassList);
export default __webpack_public_path__ + "static/media/class-list.e94b1a641b1dc99e3c8f02614813499c.svg";
export { ForwardRef as ReactComponent };